<ng-container *transloco="let t">
    <div
        *ngIf="srcFile()"
        class="bazis-file-inline"
    >
        <bazis-avatar
            *ngIf="
                extension() === 'jpeg' ||
                    extension() === 'jpg' ||
                    extension() === 'png' ||
                    extension() === 'gif';
                else tplNoImage
            "
            [src]="srcFile()"
        ></bazis-avatar>
        <ng-template #tplNoImage>
            <bazis-icon
                name="document"
                size="compact"
            ></bazis-icon>
        </ng-template>
        <div class="bh-flex-column">
            <div>
                {{ t(fileNameKey(), fileNameParams()) || nameFile() }}
            </div>
            <div class="bazis-text_minor bazis-text_secondary">
                .{{ extension() }}&nbsp;
                <span *ngIf="showFileSize()">
                    {{ sizeFile() | fileSize }}
                </span>
            </div>
        </div>
    </div>
</ng-container>
